import {AbstractControl} from "@angular/forms";

export class ValidationUtil {

  static isInvalidInput(formControl: AbstractControl): boolean {
    return formControl.invalid && (formControl.touched || formControl.dirty)
  }

  static getFormError(formControl: AbstractControl, validationName: string): any {
    return formControl.errors?.[validationName]
  }

  static isValidPhone(phone: string) {
    const phoneRegex = new RegExp("^(\\+88|0088)?01[3-9]\\d{8}$")
    return phoneRegex.test(phone)
  }

  static isValidDomain(domain: string): boolean {
    // Regular expression to match a valid domain name
    const domainRegex = /^(?!:\/\/)([a-zA-Z0-9-_]+\.)*[a-zA-Z0-9][a-zA-Z0-9-_]+\.[a-zA-Z]{2,11}?$/;

    return domainRegex.test(domain);
  }


}
